<div [formGroup]="flangeDiagramFormGroup" style="width: 100%">
    <table *ngIf="diagramDimensions !== null" class="table diagram_table">
        <thead>
            <tr>
                <ng-container *transloco="let t; read: 'STANDARD_FLANGE_PAGE.LABELS.DIAGRAM_INPUT'">
                    <th>{{ t('TABLE_KEY') }}</th>
                    <th>{{ t('TABLE_DIMENSION') }}</th>
                    <th>{{ t('TABLE_VALUE') }}</th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of diagramDimensions; trackBy: trackByKey">
                <td>{{ item.abbreviation }}</td>
                <td>{{ item.displayText }}</td>
                <td *ngIf="isEditable == false">{{ diagramMappings?.get(item.key)?.value }}</td>

                <td *ngIf="isEditable == true">
                    <div class="diagram-input-wrap">
                        <mat-form-field class="example-full-width">
                            <input
                                matInput
                                [formControlName]="item.key"
                                [name]="item.key"
                                matTooltip="{{ diagramMappings?.get(item.key)?.toolTip }}"
                                [matTooltipDisabled]="flangeDiagramFormGroup.get(item.key).valid"
                            />
                        </mat-form-field>
                        <a href="javascript:void(0)" class="custom-href"><i class="flaticon2-pen"></i></a>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
